<template>
  <v-container>
    <v-sheet outlined>
      <v-data-table
        :headers="headers"
        :items="eventItems"
        tableClasses="item-table border"
        responsive
        hide-default-footer
        disable-pagination
        fixed-header
        ref="baseTable"
      >
        <template v-slot:[`item.merchantEventType`]="{ item }">
          {{ eventTypeDisplayName(item.merchantEventType) }}
        </template>
        <template v-slot:[`item.createdTimeUtc`]="{ item }">
          {{ item.createdTimeUtc | moment }}
        </template>
      </v-data-table>
    </v-sheet>
  </v-container>
</template>
<script>
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
const businessInformationRepository = () =>
  RepoFactory.get('businessInformation');
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
const enumRepository = () => RepoFactory.get('enums');

export default {
  mixins: [asyncLoadMixin, reusableMethodsMixin],
  props: {
    merchantId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      eventTypeList: [],
      eventItems: [],
      headers: [
        {
          value: 'createdTimeUtc',
          text: 'تاریخ',
          sortable: true,
        },
        {
          value: 'occurredByName',
          text: 'رخداد توسط',
          sortable: true,
        },
        {
          value: 'description',
          text: 'توضیحات',
          sortable: true,
        },
        {
          value: 'merchantEventType',
          text: 'نوع روبداد',
          sortable: true,
        },
      ],
    };
  },
  created() {
    this.EventTypes();
    if (this.merchantId) {
      this.getData();
    }
  },
  watch: {
    merchantId(after) {
      if (after) this.getData();
    },
  },
  computed: {
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
  },
  methods: {
    eventTypeDisplayName(title) {
      if (this.eventTypeList.length) {
        let result = this.eventTypeList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    EventTypes() {
      enumRepository()
        .getEnum('MerchantEventType', this.merchantBaseUrl)
        .then((res) => {
          this.eventTypeList = res.data;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        });
    },
    getData() {
      const loader = this.$loading.show();
      businessInformationRepository()
        .getMerchantEvents(this.merchantBaseUrl, {
          MerchantId: this.merchantId,
        })
        .then((res) => {
          this.eventItems = res.data;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
};
</script>

<style></style>
